import "./styles.css";
import { createMap, spinGlobe, getMap } from "./map.ts";
import { catalog } from "./catalog.ts";
import { h, $, clear, toast } from "./dom.ts";
import { prefs } from "./prefs.ts";
import { homeScreen } from "./screens/home.ts";
import { joinRoom } from "./screens/lobby.ts";

const app = $("#app");

/** Replaces whatever screen is showing. */
export function show(el: HTMLElement) {
  clear(app);
  app.append(el);
  const first = el.querySelector<HTMLElement>("[autofocus]") ?? el.querySelector<HTMLElement>("h1");
  if (first) { if (first.tagName === "H1") first.tabIndex = -1; first.focus({ preventScroll: true }); }
}

export function goHome(opts: { code?: string } = {}) {
  history.replaceState(null, "", "/");
  spinGlobe(true);
  show(homeScreen(opts));
}

createMap($("#map"));
getMap().once("load", () => spinGlobe(true));

show(h("div", { class: "loading" }, "Loading the world…"));
catalog().then(() => {
  const m = location.pathname.match(/^\/r\/([A-Za-z0-9]{4,6})\/?$/);
  if (m) {
    const code = m[1].toUpperCase();
    if (prefs.name.trim()) joinRoom(code);
    else { goHome({ code }); toast("Add your name, then tap Join"); }
  } else if (location.pathname === "/daily") {
    goHome();
    ($("#daily-btn") as HTMLButtonElement | null)?.click();
  } else goHome();
}).catch(() => {
  show(h("div", { class: "loading" }, "Couldn’t load the place list. Check your connection and reload."));
});
